// src/context/PaginationContext.js
import { createContext, useContext, useState, useCallback } from 'react';
import axios from 'axios';

const PaginationContext = createContext();

export const PaginationProvider = ({ children }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [tools, setTools] = useState([]);

  // ✅ Manual refresh function that fetches tools only when called
  const refreshTools = useCallback(async () => {
    try {
      //below line is for our local pc but for vercel and render 
      // const res = await axios.get('http://localhost:5000/api/tools');
      // ✅ Works on Vercel (uses deployed backend)
      const res = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/tools`);
      setTools(res.data);
    } catch (err) {
      console.error('Failed to refresh tools:', err);
    }
  }, []);

  return (
    <PaginationContext.Provider
      value={{
        currentPage,
        setCurrentPage,
        tools,
        setTools,
        refreshTools, // ✅ exposed in context
      }}
    >
      {children}
    </PaginationContext.Provider>
  );
};

export const usePagination = () => useContext(PaginationContext);
